export default {
    // ========== Botón y Sidebar ==========
    pinMenu: 'Fijar menú',
    unpinMenu: 'Desfijar menú',
    artificialIntelligence: 'Inteligencia Artificial',
    artificialIntelligenceSubtitle: 'Genera sugerencias de un elemento curricular a la vez.',

    // ========== Pestañas ==========
    generator: 'Generador',
    results: 'Resultados',
    options: 'Opciones',
    advancedOptions: 'Opciones avanzadas',
    closeAdvancedOptions: 'Cerrar opciones avanzadas',

    // ========== Selectores ==========
    whatToCreate: '¿Qué desea crear?',
    selectOption: '-- Seleccione una opción --',
    select: 'Seleccione',
    select2: 'Seleccionado',
    selectA: 'Seleccione un',
    selectEntity: 'Seleccione {article} {entity}',
    selectedEntity: '{entity} seleccionada',
    willBeConsidered: 'Se considerará la',
    toGenerate: 'para generar la',
    noResultsFor: 'No se encontraron resultados para',

    // ========== Contexto y Ejemplos ==========
    from: 'del',
    of: 'de la',
    of2: 'de',
    generates: 'genera',
    example: 'ejemplo',
    examples: 'ejemplos',
    question: 'pregunta',
    questions: 'preguntas',
    writeAdditionalContext: 'Escriba un contexto adicional...',
    availableCharacters: 'Caracteres disponibles',

    // ========== Cantidad de Ejemplos ==========
    selectAmountExamples: 'Seleccione la cantidad de ejemplos que desee generar.',

    // ========== Botones ==========
    generateExamples: 'Generar ejemplos',

    // ========== Opciones Avanzadas ==========
    temperature: 'Temperatura',
    temperatureTooltip: 'Controla la aleatoriedad de los resultados. Valores bajos hacen que las respuestas sean más predecibles, mientras que valores altos generan respuestas más creativas.',
    tokensAmount: 'Cantidad de tokens a usar',
    tokensTooltip: 'Limita el número máximo de tokens (unidad de palabras y fragmentos de palabras) que la respuesta puede contener.',

    // ========== Resultados ==========
    generatingExamples: 'Generando ejemplos...',
    noExamplesGenerated: 'Aún no ha generado ningún ejemplo.',
    copyAllResults: 'Copiar todos los resultados.',
    clickToCopy: 'Haga clic para copiar el contenido.',

    // ========== Toast Messages ==========
    exampleCopied: 'Ejemplo copiado en el portapapeles',
    allExamplesCopied: 'Todos los ejemplos han sido copiados al portapapeles',

    // ========== Mensajes de Error ==========
    aiAccessBlocked: 'Acceso a la IA bloqueado',
    inappropriateUseDetected: 'Se ha detectado un uso inapropiado de la IA. Tu acceso será restringido temporalmente.',
    accept: 'Aceptar',
    lengthLimitReached: 'La generación alcanzó el límite de longitud máxima. Los ejemplos mostrados son incompletos.',
    couldNotDetermineResult: 'No se pudo determinar un resultado completo. Por favor, ajusta los parámetros e intenta nuevamente.',
    contentFilterError: 'Ocurrió un error con la respuesta ya que el contenido se considera inapropiado o sensible.',
    generationError: 'Ocurrió un error al generar los ejemplos. Por favor, intenta nuevamente.',
    serverCommunicationError: 'Error de comunicación con el servidor.',

    // ========== Contexto dinámico ==========
    evaluationIndicator: 'un {entity}',
    evaluationIndicators: '{entity}',

    // ========== Frases del pre-textarea ==========
    fromThe: 'del siguiente',
    andThe: 'y la',
    forThe: 'Para la',

    // ========== Prompts para AI (método promptRubricAchievement) ==========
    // Cada prompt es una única oración/string (sin concatenar fragmentos).
    dimensionLevelPrompt: '{dimensionEntity} {dimension}, {levelEntity} {level} generame una descripción',
    dimensionCriteriaPrompt: 'Guíandote con este {indicatorEntity}: {indicator} Solo responde con {text} en formato: Verbo, Objeto, Condición. Con verbos de la Taxonomía Marzano y Kendall. Asegúrate de que los verbos estén en tercera persona del singular.',
    questionPrompt: '{subjectEntity}: {subject}, Guíandote con este {indicatorEntity}: {indicator}, Sólo responde con Sugerencias de Preguntas que estén redactadas como de desempeño para la {evaluationEntity} según el siguiente contexto: {context}',
    contentPrompt: 'Genera contenidos temáticos para la {subjectEntity} {subject}, considerando el siguiente {learningOutcomeEntity}: {learningOutcome}.\nPresenta un listado organizado por temas y subtemas (por ejemplo: Tema 1, 1.1, 1.2; Tema 2, 2.1, 2.2).\nEntrega solo los títulos de los contenidos, sin desarrollo ni metodología.\nsolo generar {amount} temas con sus respectivos subtemas.',
    competenceCyclePrompt: '{egressProfileEntity}: {egressProfileName}, Guíandote con esta {competenceEntity}: {competence}, perteneciente al {cycleEntity} {cycleName}. Sólo responde con {text} para el ciclo: {cycleActual}, en formato: Verbo, Objeto, Condición, Contexto, con verbos de niveles 4-6 de la Taxonomía Marzano y Kendall. Con verbos de la Taxonomía Marzano y Kendall. Asegúrate de que los verbos estén en tercera persona del singular.',
    bibliographyPrompt: '{subjectEntity}: {subject}, Bibliografía de tipo: {bibliographyName}, Sólo responde con Bibliografías en formato {format}',

    // ========== Bibliographic Resources ==========
    selectType: 'Seleccione un tipo',
    selectFormat: 'Seleccione formato APA',
    selectFormatPlaceholder: 'Seleccione un formato',
}
